import {NavLink,useLocation, useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import supabase from "../supabase"

function Sidebar({changeTab,currenTab}) {
    const [jobState, SetJobs] = useState(false);
    const navigate = useNavigate()

    const location = useLocation();
        useEffect(
            () => {
            // Logic to check if the current location matches any of the links
                if (location.pathname === '/active-jobs') {
                    SetJobs(true);
                } else {
                    SetJobs(false);
                }
    },[location.pathname]);
            
    const sidebarState = useSelector(state => state.sidebarReducres);

    const onSetJob = () =>{
        navigate("/active-jobs")
    }

    const logout = async() =>{
        let { error } = await supabase.auth.signOut()
        if(!error){
          localStorage.removeItem("AccessToken")
          navigate('/login');
        }
    }

    return (
        <>
        <div className={`sidebar ${sidebarState ? 'sidebar_hide' : ''}`}>
            <div className='menu'>
                <ul className='sidebar-links'>
                    <li>
                        <NavLink to="/admin-dashboard"> <i className="fa fa-home home-icon"></i> <span className='link-text'>Dashboard</span></NavLink>
                    </li>
                    <li>
                        <div className={`${jobState ? 'active-link' : 'unactive-link'}`}>
                            <button type="button" class="accordion-button" onClick={() => onSetJob()}><i class="fa fa-rocket"></i> <span class="link-text"> Jobs</span> <i class="fa fa-circle-chevron-down"></i>
                            </button>
                        </div>
                        {jobState && (
                            <ul className={`sub-menu ${jobState ? 'sub-menu2' : ''}`}>
                                <li onClick={()=>changeTab(true)}><a className={`${currenTab?" active":" "}`}>Active Jobs</a></li>
                                <li onClick={()=>changeTab(false)}><a className={`${currenTab?" ":" active"}`}>Add Job</a></li>
                            </ul>
                        )}
                    </li>
                    <li><NavLink to="/received-aplication"> <i className="fa fa-file"></i> <span className='link-text'> Received Aplication</span></NavLink></li>
                    <li onClick={()=>logout()}><NavLink to="/"> <i class="fa fa-sign-out"></i> <span className='link-text'> Logout</span></NavLink></li>
                </ul>
            </div>
        </div>
        </>
    );
}

export default Sidebar